import React from "react";
import type { ResumeWorkExperience } from "lib/redux/types";
import { TemplateSevenResumeSection, TemplateSevenResumeSectionWithSubsections } from "./common";
import { View } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import { ResumePDFDescription, ResumePDFText } from "../ResumePDF/common";
const WorkExperience = ({
  heading,
  workExperiences,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  workExperiences: ResumeWorkExperience[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSevenResumeSectionWithSubsections themeColor={themeColor} heading={heading}>
      {workExperiences.map(
        ({ company, jobTitle, startDate, endDate, descriptions }, index) => {
          const hideCompanyName =
            index > 0 && company === workExperiences[index - 1].company;
          return (
            <View
              key={index}
              style={index !== 0 ? { marginTop: spacing["2"] } : {}}
              wrap={false}
            >
              <View
                style={{
                  ...styles.flexRowBetween,
                  marginTop: hideCompanyName
                    ? "-" + spacing["1"]
                    : spacing["1.5"],
                }}
              >
                <View
                  style={{
                    ...styles.flexRow,
                    gap: spacing["1"],
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <View>
                    <ResumePDFText
                      style={{
                        fontWeight: 900,
                      }}
                    >
                      {jobTitle}
                    </ResumePDFText>
                  </View>
                  ,{" "}
                  <View>
                    <ResumePDFText italic={true}>{company}</ResumePDFText>{" "}
                  </View>
                </View>
                <ResumePDFText>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View style={{ ...styles.flexCol, marginTop: spacing["1.5"] }}>
                <ResumePDFDescription 
                  items={descriptions}
                  enableHighlight={enableHighlight}
                  enableMistakeHighlight={enableMistakeHighlight}
                  section="experience"
                  itemIndex={index}
                />
              </View>
            </View>
          );
        }
      )}
    </TemplateSevenResumeSectionWithSubsections>
  );
};

export default WorkExperience;
